<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form"
                   v-model="form"
                   label-width="110px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="商家名称">
                  <el-input v-model="form.ptnName"
                            maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="商家编号">
                  <el-input v-model="form.ptnCode"
                            maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="负责人">
                  <el-input v-model="form.ptnOwner"
                            maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="启用状态">
                  <el-select v-model="form.actFlag">
                    <el-option label="不限"
                               value></el-option>
                    <el-option label="启用"
                               value="T"></el-option>
                    <el-option label="禁用"
                               value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item>
                  <el-button @click="dialogFormVisible = true">新增</el-button>
                  <el-button type="primary"
                             @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <el-table :data="partnerList"
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%"
                  height="500">
          <el-table-column type="index"
                           label="#"></el-table-column>
          <el-table-column prop="fid"
                           label="行业"
                           min-width="120px"
                           show-overflow-tooltip></el-table-column>

          <el-table-column prop="ptnName"
                           label="商家名称"
                           min-width="120px"></el-table-column>
          <el-table-column prop="ptnCode"
                           label="商家编号"
                           min-width="100px"></el-table-column>

          <el-table-column prop="ptnOwner"
                           label="负责人"
                           min-width="200px">
            <template slot-scope="scope">
              <el-row>负责人：{{scope.row.ptnOwner}}</el-row>
              <el-row>联系电话：{{scope.row.ownerTel}}</el-row>
              <el-row>邮箱：{{scope.row.ownerEmail}}</el-row>
            </template>
          </el-table-column>

          <el-table-column label="更新信息"
                           min-width="180px">
            <template slot-scope="scope">
              <el-row>更新者：{{scope.row.updated_user}}</el-row>
              <el-row>时间：{{scope.row.updated_at}}</el-row>
            </template>
          </el-table-column>

          <el-table-column label="创建信息"
                           min-width="180px">
            <template slot-scope="scope">
              <el-row>创建者：{{scope.row.created_user}}</el-row>
              <el-row>时间：{{scope.row.created_at}}</el-row>
            </template>
          </el-table-column>

          <el-table-column prop="actFlag"
                           label="激活状态"
                           width="100px">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.actFlag"
                         active-color="#13ce66"
                         inactive-color="#ff4949"
                         active-value="T"
                         inactive-value="F"
                         @change="chageAct(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="200px">
            <template slot-scope="scope">
              <!-- 编辑 -->
              <el-tooltip effect="dark"
                          content="编辑"
                          placement="top"
                          :enterable="false">
                <el-button type="primary"
                           icon="el-icon-edit"
                           size="mini"
                           @click="showEditDilog(scope.row)"></el-button>
              </el-tooltip>

              <!-- 删除 -->
              <el-tooltip effect="dark"
                          content="删除"
                          placement="top"
                          :enterable="false">
                <el-button type="danger"
                           icon="el-icon-delete"
                           size="mini"
                           @click="delPtn(scope.row.id)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="queryInfo.pagesize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"></el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 新增 -->
    <el-dialog title="新增商家"
               :visible.sync="dialogFormVisible"
               width="600px"
               @close="addDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="addform"
               ref="addformRef"
               :rules="rules">
        <el-form-item label="所属行业"
                      prop="fid"
                      :label-width="formLabelWidth">
          <!-- <el-input v-model="addform.xx" autocomplete="on" style="width:50%" maxlength="32"></el-input> -->
          <el-select clearable
                     v-model="addform.fid"
                     placeholder="请选择"
                     style="width: 80%">
            <el-option v-for="item in platlists"
                       :key="item.id"
                       :label="item.name"
                       :value="item.code">{{ item.name }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家名称"
                      prop="ptnName"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ptnName"
                    autocomplete="on"
                    style="width:80%"
                    maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="商家编号"
                      prop="ptnCode"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ptnCode"
                    autocomplete="on"
                    style="width:80%"
                    maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="负责人"
                      prop="ptnOwner"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ptnOwner"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ownerTel"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="ownerEmail"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ownerEmail"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态"
                      prop="actFlag"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="addform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="包含B2B" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.hasB2b">
            <el-radio label="T">是</el-radio>
            <el-radio label="F">否</el-radio>
          </el-radio-group>
        </el-form-item>-->
        <!-- <el-form-item label="安全库存" prop="actFlag" :label-width="formLabelWidth">
          <el-input placeholder="请输入数量/比例" v-model="addform.safetyStock" class="input-with-select" style="width:50%">
            <el-select v-model="addform.safetyType" slot="prepend" placeholder="请选择" style="width:120px">
              <el-option v-for="types in safetyType" :key="types.value" :label="types.label" :value="types.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>-->
        <el-form-item label="备注"
                      prop="memo"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.memo"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addPtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title="编辑商家"
               :visible.sync="editdialogFormVisible"
               width="600px"
               @close="editDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="editform"
               ref="editformRef"
               :rules="rules">
        <el-form-item label="所属行业"
                      prop="fid"
                      :label-width="formLabelWidth">
          <!-- <el-input v-model="addform.xx" autocomplete="on" style="width:50%" maxlength="32"></el-input> -->
          <el-select clearable
                     v-model="editform.fid"
                     placeholder="请选择"
                     style="width: 80%">
            <el-option v-for="item in platlists"
                       :key="item.id"
                       :label="item.name"
                       :value="item.code">{{ item.name }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家名称"
                      prop="ptnName"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ptnName"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="商家编号"
                      prop="ptnCode"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ptnCode"
                    disabled
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="负责人"
                      prop="ptnOwner"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ptnOwner"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ownerTel"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="ownerEmail"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ownerEmail"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态"
                      prop="actFlag"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="包含B2B" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.hasB2b">
            <el-radio label="T">是</el-radio>
            <el-radio label="F">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="安全库存" prop="actFlag" :label-width="formLabelWidth">
          <el-input placeholder="请输入数量/比例" v-model="editform.safetyStock" class="input-with-select" style="width:50%">
            <el-select v-model="editform.safetyType" slot="prepend" placeholder="请选择" style="width:120px">
              <el-option v-for="types in safetyType" :key="types.value" :label="types.label" :value="types.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>-->
        <el-form-item label="备注"
                      prop="memo"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.memo"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="savePtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 库存设置 -->
    <el-dialog title="库存设置"
               :visible.sync="setdialogFormVisible"
               width="50%"
               @close="setDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="setform"
               ref="setformRef"
               :rule="rules"
               size="mini">
        <el-form-item :label-width="formLabelWidth"
                      v-for="(item,index) in setform.ptnShops"
                      :key="index">
          <el-input placeholder="请输入内容"
                    v-model="item.combPercent"
                    autocomplete="on"
                    style="width:50%">
            <el-select v-model="item.disType"
                       slot="prepend"
                       placeholder="请选择"
                       style="width:130Px">
              <el-option v-for="types in allotType"
                         :key="types.value"
                         :label="types.label"
                         :value="types.value"></el-option>
            </el-select>
            <template slot="append">{{ item.shopCode }}</template>
          </el-input>
          <el-input placeholder="优先级"
                    v-model="item.priority"
                    style="width:30%"
                    type="number">
            <template slot="prepend">优先级</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="setdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="setPtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getplatlists } from '@/common/mixins/select'
export default {
  mixins: [getplatlists],
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      console.log(value)
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/
      if (regEmail.test(value) || !value) {
        return callback()
      }
      callback(new Error('请输入合法的邮箱'))
    }
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[5678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      // 符合规则
      if (regMobile.test(value) || !value) {
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }
    return {
      form: {
        ptnName: '',
        ptnCode: '',
        ptnOwner: '',
        actFlag: '',
      },
      addform: {
        fid: '',
        ptnName: '',
        ptnCode: '',
        ptnOwner: '',
        ownerTel: '',
        ownerEmail: '',
        actFlag: 'T',
        hasB2b: '',
        safetyStock: '',
        safetyType: 1,
        memo: '',
      },
      editform: {
        fid: '',
        ptnName: '',
        ptnCode: '',
        ptnOwner: '',
        ownerTel: '',
        ownerEmail: '',
        actFlag: '',
        hasB2b: '',
        safetyStock: '',
        safetyType: 1,
        memo: '',
      },
      setform: {
        ptnShops: [],
      },
      allotType: [
        { value: '1', label: '按比例%' },
        { value: '2', label: '固定数量' },
      ],
      safetyType: [
        { value: '0', label: '不设置' },
        { value: '1', label: '固定数量' },
        { value: '2', label: '按比例' },
      ],

      num: 1,
      dialogFormVisible: false,
      editdialogFormVisible: false,
      setdialogFormVisible: false,
      formLabelWidth: '120px',
      selvalue: '',
      rules: {
        ptnName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        fid: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        ptnOwner: [
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],

        ptnCode: [
          { required: true, message: '请输入商家编号', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        actFlag: { required: true, message: '必填项', trigger: 'blur' },
        ownerEmail: [{ validator: checkEmail, trigger: 'blur' }],
        ownerTel: [{ validator: checkMobile, trigger: 'blur' }],
      },
      partnerList: [],
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      total: 0,
      errmsg: '',
      loading: true,
    }
  },
  methods: {
    // 获取商家列表
    async getPartnerlist() {
      this.loading = true
      await this.$http
        .post('ptnlists', this.queryInfo)
        .then((response) => {
          const res = response.data

          this.partnerList = res.data.data

          this.total = res.data.total

          this.currentPage = res.data.current_page

          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          return this.$message.error(error.response.data.message)
        })
    },
    onSubmit() {
      this.queryInfo.pagenum = 1
      this.currentPage = 1
      this.queryInfo.query = this.form
      this.getPartnerlist()
    },

    handleSizeChange(val) {
      this.queryInfo.pagesize = val

      this.getPartnerlist()
    },

    handleCurrentChange(val) {
      this.queryInfo.pagenum = val

      this.getPartnerlist()
    },

    // 关闭新增窗口
    addDilogClosed() {
      this.$refs.addformRef.resetFields()
    },
    // 关闭编辑窗口
    editDilogClosed() {
      this.$refs.editformRef.resetFields()
    },
    // 关闭库存设置窗口
    setDilogClosed() {
      this.$refs.setformRef.resetFields()
    },
    // 点击添加商家
    async addPtn() {
      let isValid
      this.$refs.addformRef.validate((valid) => {
        isValid = valid
      })
      if (!isValid) return
      console.log('isValid', isValid)
      await this.$http
        .post('addptn', this.addform)
        .then((response) => {
          this.$message.success('添加商家成功')

          this.dialogFormVisible = false

          this.getPartnerlist()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // // 点击添加商家
    // async savePtn() {
    //   let isValid
    //   this.$refs.editformRef.validate((valid) => {
    //     isValid = valid
    //   })
    //   if (!isValid) return
    //   console.log('isValid', isValid)
    //   await this.$http
    //     .post('editptn', this.editform)
    //     .then((response) => {
    //       this.$message.success('编辑商家成功')

    //       this.editdialogFormVisible = false

    //       this.getPartnerlist()
    //     })
    //     .catch((error) => {
    //       return this.$message.error(error.response.data.message)
    //     })
    //   // });
    // },
    // 保存商家信息
    async savePtn() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;
      let isValid
      this.$refs.editformRef.validate((valid) => {
        isValid = valid
      })
      if (!isValid) return
      await this.$http
        .post('editptn', this.editform)
        .then((response) => {
          this.$message.success('编辑商家成功')

          this.editdialogFormVisible = false

          this.getPartnerlist()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 保存库存设置
    setPtn() {
      // updateptnshop

      // this.$refs.setformRef.validate(async (valid) => {
      this.$http
        .post('updateptnshop', { ptnShops: this.setform.ptnShops })
        .then((response) => {
          this.$message.success('操作成功')
          this.setdialogFormVisible = false
          this.getPartnerlist()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 变更激活状态
    async chageAct(partnerInfo) {
      await this.$http
        .put('actptn/' + partnerInfo.id + '/' + partnerInfo.actFlag)
        .then((response) => {
          const res = response.data
          this.$message.success(res.data)
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })

      this.getPartnerlist()
    },
    // 显示修改商家对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row)
      this.editform = copy
      this.editdialogFormVisible = true
    },

    // 删除商家
    async delPtn(ptnid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除该商家, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)

      // 确认删除
      if (confirmResult == 'confirm') {
        await this.$http
          .delete('delptn/' + ptnid)
          .then((response) => {
            this.$message.success('删除成功')

            this.getPartnerlist()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },
  },
  // 页面加载前
  created() {
    this.getPartnerlist()
  },
}
</script>

<style lang="less" scoped>
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/partner/index.vue